module.exports = __webpack_public_path__ + "img/corpsBanner.20fe6276.jpg";